import React from 'react'
import styled from 'styled-components'
function Spacer({ spacer }) {
    const Spacer = styled.div`
    height: ${spacer?.height?.mobile}px;
    @media (min-width: 1024px) {
        height: ${spacer?.height?.desktop || '0'}px}
    }
   `
    return <Spacer />
}

export default Spacer
